import { useEffect } from "react";
import { Route, useParams } from "react-router-dom";

import PoliticState from "../../context/ConfigPayrollContext/PoliticState";
import ConfrontaTable from "./ConfrontaTable";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
};

const ConfrontaTab = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;
    const params = useParams<any>();
    useEffect(() => {
    }, [params]);
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <PoliticState>
                    <Route
                        component={() => (
                        <ConfrontaTable {...props} />
                        )}
                    />
                </PoliticState>
            )}
        </div>
    )
}

export default ConfrontaTab;
